import { openGlobalDialog } from "../globalEditDialogActions";
import { MULTIPLE_FILE_UPLOAD_CANCELED, CLOSE_REACT_DIALOG } from "../types";
import { ERROR_CODES } from "./constants";
import { bulkUploadMultipleFiles } from "./index";

export function handleDuplicateError({
	err,
	matterID,
	basepath,
	directoryID,
	files,
	callback,
	dispatch,
	userIgnoredTheLimit,
}) {
	const { lxwErrorCode, lxwErrorData } = err;

	if (lxwErrorCode === ERROR_CODES.DUPLICATE_WITH_SPECIAL_CHARS) {
		// duplicate names and folder names with special characters
		const { numFiles, numFolders, foldersWithBadSpecialChars } =
			lxwErrorData;
		let labelMessage;
		if (numFiles && numFolders) {
			labelMessage = `${numFiles} Duplicate File(s) Found and ${numFolders} Duplicate Folder(s) Found`;
		} else if (numFiles) {
			labelMessage = `${numFiles} Duplicate File(s) Found`;
		} else if (numFolders) {
			labelMessage = `${numFolders} Duplicate Folder(s) Found`;
		}
		openGlobalDialog(
			{
				label:
					labelMessage +
					`\n${foldersWithBadSpecialChars.length} Folders have invalid characters and will be automatically renamed`,
				mainText: `Do you want to automatically rename and upload?`,
				canSubmit: true,
				hideTextfield: true,
				submitButtonLabel: "Rename and Upload",
			},
			() =>
				//call again with autoRename true
				bulkUploadMultipleFiles({
					matterID,
					basepath,
					directoryID,
					files,
					autoRename: true,
					callback,
					userIgnoredTheLimit,
				})(dispatch),
			() => ({ canSubmit: true }),
			() => {
				dispatch({
					type: MULTIPLE_FILE_UPLOAD_CANCELED,
				});
				dispatch({
					type: CLOSE_REACT_DIALOG,
				});
			}
		)(dispatch);
		return true;
	} else if (lxwErrorCode === ERROR_CODES.SPECIAL_CHARS_ONLY) {
		// folder names have special characters
		const { foldersWithBadSpecialChars } = lxwErrorData;
		openGlobalDialog(
			{
				label: `${foldersWithBadSpecialChars.length} Folders have invalid characters and will be automatically renamed`,
				mainText: `Do you want to automatically rename and upload?`,
				canSubmit: true,
				hideTextfield: true,
				submitButtonLabel: "Rename and Upload",
			},
			() =>
				//call again with autoRename true
				bulkUploadMultipleFiles({
					matterID,
					basepath,
					directoryID,
					files,
					autoRename: true,
					callback,
					userIgnoredTheLimit,
				})(dispatch),
			() => ({ canSubmit: true }),
			() => {
				dispatch({
					type: MULTIPLE_FILE_UPLOAD_CANCELED,
				});
			}
		)(dispatch);
		return true;
	} else if (lxwErrorCode === ERROR_CODES.DUPLICATE_ONLY) {
		const { numFiles, numFolders } = lxwErrorData;
		let labelMessage;
		if (numFiles && numFolders) {
			labelMessage = `${numFiles} Duplicate File(s) Found and ${numFolders} Duplicate Folder(s) Found`;
		} else if (numFiles) {
			labelMessage = `${numFiles} Duplicate File(s) Found`;
		} else if (numFolders) {
			labelMessage = `${numFolders} Duplicate Folder(s) Found`;
		}
		openGlobalDialog(
			{
				label: labelMessage,
				mainText: `Do you want to rename duplicates and upload?`,
				canSubmit: true,
				hideTextfield: true,
				submitButtonLabel: "Rename and Upload",
			},
			() =>
				//call again with autoRename true
				bulkUploadMultipleFiles({
					matterID,
					basepath,
					directoryID,
					files,
					autoRename: true,
					callback,
					userIgnoredTheLimit,
				})(dispatch),
			() => ({ canSubmit: true }),
			() => {
				dispatch({
					type: MULTIPLE_FILE_UPLOAD_CANCELED,
				});
				dispatch({
					type: CLOSE_REACT_DIALOG,
				});
			}
		)(dispatch);
		return true;
	}
	return false;
}
